import { Record, Map } from 'immutable';
import UserPicture from './userPicture';

const UserRecord = Record({
  id: undefined,
  displayName: undefined,
  userPicture: UserPicture,
  _links: new Map(),
  _forms: new Map()
});

class User extends UserRecord {

  constructor(props) {
    props.userPicture = new UserPicture(props.userPicture);

    super(props);
  }

  getLink(linkName) {
    return this._links[linkName];
  }

  getForm(formName) {
    return this._forms[formName];
  }

}

export default User;


// WEBPACK FOOTER //
// ./src/api/models/user.js